<div class="container">
  <div class="aside" #aside>
    <ng-content select="[aside]"></ng-content>
  </div>
  <div class="main">
    <ng-content select="[main]"></ng-content>
  </div>
</div>
